import { LangSelectorBtn } from "../../../../components";
import { envChangeType } from "../../../../plugins/utils";
import styles from "./style.module.scss";
function Header() {
  return (
    <div className={`${styles.header}`}>
      <div className={`${styles.logaArea}`}>
        <img
          style={{ width: 120, marginLeft: 16 }}
          src={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/logo.png`}
          alt="logo"
        />
      </div>
      <div className={`${styles.langArea}`} style={{ padding: "0px 16px" }}>
        <LangSelectorBtn />
      </div>
    </div>
  );
}

export default Header;
